import { render, staticRenderFns } from "./legalDetails.vue?vue&type=template&id=87912670&"
import script from "./legalDetails.vue?vue&type=script&lang=js&"
export * from "./legalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports